import React from 'react'

function AppSection() {
    return (
        <div className="row">
            <div className="col-md-6">
                <div className="card">
                    <a href="https://apps.apple.com/us/app/id1526845196">
                        <img src="https://progitek.no/privat/bp/wp-content/uploads/2020/09/app-store-1.png" alt="footgrail-app-store" className="img-fluid" />
                    </a>
                </div>
            </div>
            <div className="col-md-6">
                <div className="card">
                    <a href="https://play.google.com/store/apps/details?id=com.progitek.footgrail&hl=no">
                        <img src="https://progitek.no/privat/bp/wp-content/uploads/2020/09/google-play-1.png" alt="footgrail-play-store" className="img-fluid" />
                    </a>
                </div>
            </div>
        </div>
    )
}
export default AppSection